// Identificação de transportadoras por NOME (o ERPApi resolve provider por prefixo do
// nome em isEligibleShippingProvider/isCorreiosShippingProvider — manter em sincronia).

/** Integração direta Correios (ProviderId 10). 'melhorenvio - correios' NÃO começa com 'correios'. */
export const isCorreiosProviderName = (name?: string | null): boolean =>
  (name ?? '').trim().toLowerCase().startsWith('correios');

/** Transportadoras com integração de pedido de envio (tela /shipping-orders). */
export const isEligibleProviderName = (name?: string | null): boolean => {
  const normalized = (name ?? '').trim().toLowerCase();
  return (
    normalized.startsWith('fmtransportes') ||
    normalized.startsWith('melhorenvio') ||
    normalized.startsWith('correios')
  );
};
